import React, { useEffect, useState, Fragment, useRef } from "react";
import { Checkbox } from "@material-ui/core";
import { LoadingMaterialTable } from "../../../Common/table";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createpdf";

var QRCode = require("qrcode.react");

export const BagQRPrintListing = (props) => {
  const componentRef = useRef();
  const { bagQRTags } = props;

  const [qrTags, setQRTags] = useState([]);
  const [saveData, setSaveData] = useState([]);

  useEffect(() => {
    if (Array.isArray(bagQRTags)) {
      setQRTags(bagQRTags);
    } else if (bagQRTags && Array.isArray(bagQRTags.data)) {

      setQRTags(bagQRTags.data);
    } else if (bagQRTags && Array.isArray(bagQRTags.list)) {

      setQRTags(bagQRTags.list);
    } else {
      setQRTags([]);
    }

    setSaveData([]);
  }, [bagQRTags]);

  function getTagKey(data) {
    return String(data.collectionTagID || data.CollectionTagID || data.tagNo);
  }

  function handleClick(data) {
    const tagKey = getTagKey(data);
    const isSelected = saveData.some((x) => getTagKey(x) === tagKey);

    if (isSelected) {
      setSaveData(saveData.filter((x) => getTagKey(x) !== tagKey));
    } else {
      setSaveData([
        ...saveData,
        {
          collectionTagID: data.collectionTagID || data.CollectionTagID,
          tagNo: data.tagNo,
        },
      ]);
    }
  }

  function handleClickAll(e) {
    if (e.target.checked) {
      setSaveData(
        qrTags.map((x) => ({
          collectionTagID: x.collectionTagID || x.CollectionTagID,
          tagNo: x.tagNo,
        }))
      );
    } else {
      setSaveData([]);
    }
  }

  return (
    <Fragment>
      <LoadingMaterialTable
        title=""
        columns={[
          {
            title: (
              <label>
                <Checkbox
                  color="primary"
                  onChange={handleClickAll}
                  checked={
                    qrTags.length > 0 &&
                    qrTags.every((x) =>
                      saveData.some((y) => getTagKey(y) === getTagKey(x))
                    )
                  }
                />
                Select All
              </label>
            ),
            sorting: false,
            field: "select",
            type: "boolean",
            render: (rowData) => (
              <Checkbox
                color="primary"
                checked={saveData.some((x) => getTagKey(x) === getTagKey(rowData))}
                onChange={() => handleClick(rowData)}
              />
            ),
          },
          {
            title: "Tag Number",
            field: "tagNo",
          },
          {
            title: "QR Code",
            field: "qrCode",
            render: (rowData) => (
              <QRCode value={String(rowData.tagNo || "")} size={56} />
            ),
          },
        ]}
        data={Array.isArray(qrTags) ? qrTags : []}
      />

      <div className="card-footer">
        <ReactToPrint
          trigger={() => (
            <input
              type="button"
              className="btn btn-primary pull-right ml-2"
              value="Create PDF"
              disabled={saveData.length === 0}
            />
          )}
          content={() => componentRef.current}
        />
      </div>

      <div hidden>
        <CreatePdf data={saveData} ref={componentRef} />
      </div>
    </Fragment>
  );
};